import React, { useEffect, useState } from "react";
import './index.css'
import { compareTeams, orderTeams } from "../positionTeams/utils/orderTeams.js";
import axios from "axios";
import { useSelector } from "react-redux";
import { secureUrl } from "../../../../utils/sortArray/secureUrl.js";
import useIsMobileAndPortrait from "../../../../hooks/useIsMobile.js";
import SponsorsFooter from "../matchGames/components/matchGame/components/SponsorsFoooter/index.js";

const GeneralPostionTable = ()=>{
    const selectedTournament = useSelector(state => state?.tournaments?.selectedTournament)
    const [teamsByTournament, setTeamsByTournament] = useState([])
    const { isMobile, isPortrait } = useIsMobileAndPortrait();


    const fetchAllTeams = async () =>{
       const result = await axios.post('https://web-production-58ed.up.railway.app/api/dt/getteams/bytorneo',{torneo: selectedTournament._id})
       const equiposResult = result?.data?.positionTeams?.sort(compareTeams)
       setTeamsByTournament(equiposResult?.filter(team => team?.esBaja !== true))
    }

    useEffect(()=>{
        fetchAllTeams();

    },[])

        return(
            <div className="talachaapp-body-tablageneral">
        <div className="talachaapp-body-tableposotion">
            <div className="talachaapp-header-container-table">
            <p className="talachaapp-title-group">{'Tabla General'}</p>
            <div className="talachaapp-tournamen-img-container">
                <img src={secureUrl(selectedTournament?.imgPicture)} />
                <p>{selectedTournament?.name}</p>
            </div>


            </div>
            <div className="tatalachaapp-header-title">
                <div className="tatalachaapp-header-title-nameTeam">
    Equipo
                </div>
                <div>
                    PTS
                </div>
               <div>
                <p>PJ</p>
                </div>
                {
                    !isMobile && (
                        <>
                                        <div>
                <p>G</p>
    
                </div>
                <div>
                <p>E</p>
    
                </div>
                <div>            <p>P</p>
    
                </div>
                        </>
                    )
                }
                <div>
                <p>GF</p>
    
                </div>
                <div>
                <p>GC</p>
    
                </div>
                <div>
                <p>DG</p>
    
                </div>
      
            </div>
            <div className="talachaapp-body-table-all-teams">
            {
                    teamsByTournament?.map((team, index) => (
                        <div className="talachaapp-body-teams">
    
                        <div className="tatalachaapp-body-teams-nameTeam">
                        <p className="tatalachaapp-body-teams-nameTeam-position-general">{index + 1}</p> 


                            <img className="team-img-talacha-table" src={secureUrl(team?.img)} />
                            <span className="tatalachaapp-body-teams-remark-item">{team?.name}</span>
                            </div>
                            <div>
                              <span className="tatalachaapp-body-teams-remark-item">{team?.TotalPuntos}</span>
                            </div>
                           <div>
                            <p>{team?.jornadas}</p>
                            </div>
                            {
                                !isMobile && (
                                    <>
                                                                <div>
                            <p>{team?.result.ganados || 0}</p>
                
                            </div>
                            <div>
                            <p>{team?.result?.empatados || 0}</p>                
                            </div>
                            <div>
                            <p>{team?.result?.perdidos || 0}</p>

                            </div>
                                    </>
                                )
                            }

                            <div>
                            <p>{team?.TotalGolesA}</p>
                
                            </div>
                            <div>
                            <p>{team?.TotalGolesC}</p>
                
                            </div>
                            <div>
                            <p>{team?.TotalGolesA - team?.TotalGolesC }</p>
                
                            </div>                
                        </div>
                    ))
                }
            <SponsorsFooter />
            </div>

    
    
    
    
        </div>
            </div>
)
}

export default GeneralPostionTable;